"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

/**
 * File icon - represents a generic file.
 * Used in file import/export interfaces.
 */
var File = function File(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    role: "img",
    "aria-hidden": "true",
    focusable: "false",
    fill: "none"
  }, props), (0, _preact.h)("path", {
    d: "M9.33329 1.83334H3.99996C3.26663 1.83334 2.67329 2.43334 2.67329 3.16668L2.66663 13.8333C2.66663 14.5667 3.25996 15.1667 3.99329 15.1667H12C12.7333 15.1667 13.3333 14.5667 13.3333 13.8333V5.83334L9.33329 1.83334ZM3.99996 13.8333V3.16668H8.66663V6.50001H12V13.8333H3.99996Z",
    fill: "currentColor"
  }));
};

var _default = File;
exports.default = _default;